import { makeAsyncActionCreator } from 'services/store/utils-actions';
import updateRemoteDocument from 'services/store/utils/actions/updateRemoteDocument';
import { calculateTimeSlots } from 'utils/schedules/calculateTimeSlots';
import { sortBlocksByTimeSlots } from 'utils/schedules/sortBlocksByTimeSlots';
import { assertValidScheduleBlocks } from 'utils/schedules/assertValidScheduleBlocks';
import { collection, statusTypes, types } from '../definitions';

/**
 * Projects a scheduler block (or an already-projected `{ todo, start }` view block) to the
 * stored `views.schedule.blocks` shape.
 */
export const toScheduleViewBlock = ({ start, todo, intent }) => (
  !intent ? {
    todo,
    start: start != null ? `${start}` : undefined,
  } : {
    todo: intent.todo.id,
    start: intent.start.toString(),
  }
);

/**
 * Sorts view blocks into schedule order for persistence.
 */
export const toSortedScheduleViewBlocks = (schedule, viewBlocksOrScheduledBlocks) =>
  sortBlocksByTimeSlots(
    viewBlocksOrScheduledBlocks.map(toScheduleViewBlock).filter(block => block.todo),
    calculateTimeSlots(schedule.startTime, schedule.endTime, 15)
  );

const updateScheduleViewImpl = makeAsyncActionCreator({
  type: types.UPDATE_SCHEDULE,
  creator: async (schedule, viewBlocksOrScheduledBlocks) => {
    const blocks = toSortedScheduleViewBlocks(schedule, viewBlocksOrScheduledBlocks);

    // Refuse to write a corrupt array (duplicate starts / duplicate todos) — corrupt
    // stored data historically deleted intents on the next rebuild. Callers of this
    // action legitimately add and remove blocks, so identity is not constrained here.
    assertValidScheduleBlocks(blocks, 'updateScheduleView');

    return await updateRemoteDocument(collection, schedule.id, {
      'views.schedule.blocks': blocks,
    });
  },
  status: {
    path: collection,
    type: statusTypes.updateScheduleView,
    parameters: (id, _changes) => [ id ],
  }
});

const updateScheduleView = (schedule, blocks) => async (dispatch) => (
  await dispatch(updateScheduleViewImpl(schedule, blocks))
);

export default updateScheduleView;
